const PROCEDURES_GRID_COLUMNS = "300px 1fr";

export { PROCEDURES_GRID_COLUMNS };
